// link — default skin module
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: inline;
    box-sizing: border-box;
  }

  :host([disabled]) {
    cursor: not-allowed;
    pointer-events: none;
  }

  [part="base"] {
    display: inline;
    color: var(--run-link-color, var(--run-color-intent-primary-base, #2563eb));
    text-decoration: underline;
    text-underline-offset: var(--run-link-underline-offset, 0.15em);
    cursor: pointer;
    outline: none;
    transition: color 150ms ease;
    font: inherit;
  }

  [part="base"]:hover {
    color: var(--run-link-color-hover, var(--run-color-intent-primary-hover, #1d4ed8));
  }

  [part="base"]:visited {
    color: var(--run-link-color-visited, var(--run-color-intent-primary-active, #1e40af));
  }

  :host([disabled]) [part="base"] {
    color: var(--run-link-color-disabled, var(--run-color-text-disabled, #94a3b8));
    text-decoration-style: solid;
    cursor: not-allowed;
  }

  :host(:focus-visible) [part="base"],
  :host([data-focus-visible]) [part="base"] {
    outline: var(--run-link-focus-ring-width, 2px) solid
      var(--run-link-focus-ring-color, var(--run-color-focus-ring, #2563eb));
    outline-offset: var(--run-link-focus-ring-offset, var(--run-space-semantic-xs, 2px));
    border-radius: 2px;
  }

  [part="prefix"],
  [part="suffix"] {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
  }

  [part="suffix"] .external-icon {
    display: inline-flex;
    align-items: center;
    margin-left: var(--run-link-external-icon-gap, var(--run-space-semantic-xs, 4px));
    vertical-align: middle;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    white-space: nowrap;
    border: 0;
  }
`;

const EXTERNAL_SVG = `<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"
  fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
  <path d="M5 2H2a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1V7"/>
  <path d="M8 1h3m0 0v3m0-3L5.5 6.5"/>
</svg>`;

export function render(host) {
  const externalSuffix = host.external
    ? `<span class="external-icon">${EXTERNAL_SVG}</span><span class="sr-only">(opens in new tab)</span>`
    : '';

  host.shadowRoot.innerHTML = `
    <a part="base" tabindex="-1">
      <span part="prefix"><slot name="prefix"></slot></span><slot></slot><span part="suffix">${externalSuffix}<slot name="suffix"></slot></span>
    </a>
  `;

  // Set anchor attributes via DOM API to avoid injection from href values.
  const anchor = host.shadowRoot.querySelector('[part="base"]');
  if (host.href && !host.disabled) anchor.setAttribute('href', host.href);
  if (host.target) anchor.setAttribute('target', host.target);
  if (host.rel) anchor.setAttribute('rel', host.rel);
  if (host.download) anchor.setAttribute('download', host.download);
}
